<kiwi-competitive-intelligence
    [barChartLabel]="'studies.competitive.intelligence.quality'"
    [teamValueLabelKey]="'studies.competitive.intelligence.quality'"
    [comparisonStudy]="study"
></kiwi-competitive-intelligence>
